import { COLORS } from 'helpers/globals'

export default {
  fixed: {
    fontWeight: '200',
    color: COLORS.secondary,
    fontSize: '1.2rem',
    marginLeft: '1rem'
  },
  degree: {
    color: 'black',
    marginLeft: '.3rem',
    fontSize: '1.5rem'
  },
  bottomRowButton: {
    fontSize: '1.8rem',
    marginLeft: '1rem',
    color: '#428bca',
    cursor: 'pointer'
  }
}



// WEBPACK FOOTER //
// ./src/components/AngleOfViewContainer/FixedAngleOfViewDisplay/style.js